import React from 'react';
import { Carousel  } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import './Apartment.css'
const Apartment = () => {
    const navigate = useNavigate();

    const Goback = () => {
        navigate('/home')
    }
    return (
    
            <div className="container mt-5 pageColor">
                <h3 style={{cursor:"pointer"}} onClick={Goback} className="fs-4  text-white fw-bolder">← Back </h3>
                
                <h1 className="text-center p-5 text-white fw-bolder">Apartment Sell USA Website</h1>
               
{/* ------------------------------  */}
            
 <Carousel  style={{ textAlign:'center'}}  fade>
  <Carousel.Item className="container">
    <img
      className="d-block w-100"
      src="https://i.ibb.co/H2ZxK5S/remx-1.png"
      alt="First slide"
    />
    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/DQsLp08/remx-2.png"
      alt="Second slide"
    />

    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/d2qWtSf/remx-3.png"
      alt="Third slide"
    />

    <Carousel.Caption>
    </Carousel.Caption>
  </Carousel.Item>
 </Carousel>
{/* ------------------------------  */}

          <br />  
          <br />  
          <br />
          <h5 className="ps-2 w-100 text-white"> This is Apartment Selling Site . Technologies use : React js, Firebase, Bootstrap, React Router, Node js, Express Js, MongoDb . You can  Sign Up and Log In  this Website .You can add to card , see your order and cancel your order. This Website is Fully Responsive . Thanks ....
        </h5>  
        
        <br />
            <div className=" container grid-button  p-5  justify-content-center   ">
                    <a className="  box btn  text-primary    fw-bolder " href="https://github.com/RonyMiah/Remax-APT-assinment-12-work-8"> <p>Git-Hub client</p> </a>
                        <a className="me-1 box text-primary  btn   fw-bolder "  href="https://github.com/RonyMiah/Remax-APT-server-side-assinment-12-work-8" ><p> Git-Hub server</p> </a>
                        <a className="box text-primary  btn    fw-bolder " href="https://remx-apt.web.app/"> <p>Live site</p> </a>
                        <NavLink className="box text-primary btn  fw-bolder " to="/blogs"> <p>Blogs</p> </NavLink>
            </div>

        </div>
    
    );
};

export default Apartment;